export function Page404() {
  return (
    <pre
      style={{
        margin: "10px 0",
        minHeight: "30vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {String.raw`
    d8888   .d8888b.      d8888 
   d8P888  d88P  Y88b    d8P888 
  d8P 888  888    888   d8P 888 
 d8P  888  888    888  d8P  888 
d88   888  888    888 d88   888 
8888888888 888    888 8888888888
      888  Y88b  d88P       888 
      888   'Y8888P'        888 
  `}
    </pre>
  );
}
